import React from 'react'
import { Select } from 'components/forms'
import { GridCell, SelectGrid } from './StyledGridSelector'
import { useTranslation } from 'react-i18next'

const GridSelector = ({ dimensions, onChange, ...props }) => {
	const [t] = useTranslation()
	const generateOptions = () => {
		const out = []
		for (let i = 1; i <= 50; i += 1) {
			const w = (i % 5 === 0 ? 5 : i % 5), h = Math.ceil((i === 0 ? 1 : i) / 5)
			out.push({
				label: `${t('category_section.strings.grid_buttons')} ${w}x${h}`,
				value: [ h, w ]
			})
		}
		return out
	}
	const gridRenderer = ({ children, ...rest }) => {
		const { props: { data: { value: [focusedH, focusedW] } } } = children.find(({ props: { isFocused } }) => isFocused)
		const grid = children.map(({ props: { data, innerProps: { onClick, onMouseMove, onMouseOver } } }, i) => {
			const { value: [ h, w ] } = data
			const isFocused = h <= focusedH && w <= focusedW
			return <GridCell key={i} isFocused={isFocused} onClick={onClick} onMouseMove={onMouseMove} onMouseOver={onMouseOver}/>
		})
		return(
			<SelectGrid {...rest}>
				{grid}
			</SelectGrid>
		)
	}
	const setValue = vals => {
		if(!vals) {
			return null
		}
		const [h, w] = vals
		return ({
			label: `${t('category_section.strings.grid_buttons')} ${w}x${h}`,
			value: [ h, w ]
		})
	}
	return(
		<Select
			{...props}
			field='dimensions'
			beforeSetSelectValue={setValue}
			options={generateOptions(dimensions)}
			components={{ MenuList: gridRenderer }}
		/>
	)
}

export default GridSelector
